// Shared constants for the Trend Analysis (PeriodAnalysis) workspace.

export const GRANULARITIES = [
  { id: 'daily', label: 'Daily', days: 1 },
  { id: 'weekly', label: 'Weekly', days: 7 },
  { id: 'biweekly', label: 'Bi-Weekly', days: 14 },
  { id: 'monthly', label: 'Monthly', days: 30 },
  { id: 'quarterly', label: 'Quarterly', days: 90 }
];

export const DATE_PRESETS = [
  { id: 'last4weeks', label: 'Last 4 Weeks', weeks: 4 },
  { id: 'last3months', label: 'Last 3 Months', weeks: 13 },
  { id: 'last6months', label: 'Last 6 Months', weeks: 26 },
  { id: 'ytd', label: 'YTD', weeks: null },
  { id: 'all', label: 'All Time', weeks: null }
];

export const METRIC_COLORS = {
  total_hours: '#2E5C8A',
  premium_hours: '#FF8C42',
  non_premium_hours: '#4CAF93',
  headcount: '#8b5cf6',
  premium_percent: '#ef4444',
  rolling_avg: '#8b5cf6'
};

export const SAVED_VIEWS_KEY = 'overtimeiq_saved_views';

export function loadSavedViews() {
  try {
    const raw = localStorage.getItem(SAVED_VIEWS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

export function persistSavedViews(views) {
  localStorage.setItem(SAVED_VIEWS_KEY, JSON.stringify(views));
}
